export const TEACHER_DETAIL_TAB_KEYS = {
  TEACHER_INFO: 'teacherInfo',
  TEACHER_LOG: 'teacherLog',
  WITHDRAWAL: 'withdrawal',
  TRANSACTION_HISTORY: 'transactionHistory',
}
